/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Tape,
    TapeFromJSON,
    TapeFromJSONTyped,
    TapeToJSON,
} from './';

/**
 * 
 * @export
 * @interface TapeFile
 */
export interface TapeFile {
    /**
     * 
     * @type {number}
     * @memberof TapeFile
     */
    id: number;
    /**
     * 
     * @type {Tape}
     * @memberof TapeFile
     */
    tape: Tape;
    /**
     * 
     * @type {string}
     * @memberof TapeFile
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof TapeFile
     */
    readonly searchHighlight: string;
    /**
     * 
     * @type {number}
     * @memberof TapeFile
     */
    uid: number;
    /**
     * 
     * @type {string}
     * @memberof TapeFile
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof TapeFile
     */
    isDir?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TapeFile
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TapeFile
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof TapeFile
     */
    checksum?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TapeFile
     */
    fullpath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TapeFile
     */
    parent?: number | null;
}

export function TapeFileFromJSON(json: any): TapeFile {
    return TapeFileFromJSONTyped(json, false);
}

export function TapeFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tape': TapeFromJSON(json['tape']),
        'path': json['path'],
        'searchHighlight': json['search_highlight'],
        'uid': json['uid'],
        'name': json['name'],
        'isDir': !exists(json, 'is_dir') ? undefined : json['is_dir'],
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'checksum': !exists(json, 'checksum') ? undefined : json['checksum'],
        'fullpath': !exists(json, 'fullpath') ? undefined : json['fullpath'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
    };
}

export function TapeFileToJSON(value?: TapeFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tape': TapeToJSON(value.tape),
        'path': value.path,
        'uid': value.uid,
        'name': value.name,
        'is_dir': value.isDir,
        'read_only': value.readOnly,
        'length': value.length,
        'checksum': value.checksum,
        'fullpath': value.fullpath,
        'parent': value.parent,
    };
}


